import {IDirective, IDirectiveFactory, IHttpService} from 'angular';
import IPromise = angular.IPromise;
import ITimeoutService = angular.ITimeoutService;

export class DVHTTPLoading implements IDirective {
    restrict = 'A';
    controller = DVHTTPLoadingController;
    controllerAs = 'vm';

    link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: DVHTTPLoadingController) => {
        let promise: IPromise<any>;
        scope.$watch(controller.isLoading, (v) => {

            if (v) {
                controller.$timeout.cancel(promise);
                element.show();
            } else {
                promise = controller.$timeout(() => {
                    element.hide();
                }, 500);

            }
        });

    };

    static factory(): IDirectiveFactory {
        const directive = () => new DVHTTPLoading();
        directive.$inject = [];
        return directive;
    }
}

/**
 * Direktive  die ein Element ein oder ausblendet jenachdem ob ein http request pending ist
 */
export class DVHTTPLoadingController {

    static $inject: string[] = ['$http', '$timeout'];

    isLoading: () => {};
    dvHttpLoading: any;

    /* @ngInject */
    constructor(private $http: IHttpService, public $timeout: ITimeoutService) {

        this.isLoading = (): boolean => {
            return this.$http.pendingRequests.length > 0;
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/core/directive/dv-loading-http/dv-http-loading.ts